@use '../../../../../styles/Colors.scss' as Colors;
@use '../../../../../styles/Constants.scss' as Constants;
@use '../../../../../components/Table/styles.module.scss' as Table;

$var-shadow: 0 1px 4px 0 Colors.$col-shadow;
$var-submit-action-top-offset: -16px;
$var-tabs-navigation-top-offset: 48px;
$var-lost-for-reason-width: 250px;

.invoice {

	&__table-header {
		font-size: Constants.$val-fontSizeSmall;

		&>span {
			text-transform: uppercase;
		}

		&>b {
			margin-left: Constants.$val-spacing-xs;
			margin-right: Constants.$val-spacing-l;
		}
	}

	&__sub-row-cell {
		color: Colors.$col-greyFontLight;
	}

	&__no-billing-code {
		color: Colors.$col-greyFontLight;
		font-style: italic;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	&__empty-cell {
		color: Colors.$col-greyFontLight;

		&--right-aligned {
			display: flex;
			justify-content: flex-end;
			width: 100%;
		}
	}

	&__status-cell {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;

		&--draft {
			[class^="icon-draft"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-design-gray6;
			}
		}

		&--invoiced {
			[class^="icon-invoice_status_invoiced"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-orange;
			}
		}

		&--partially-paid {
			[class^="icon-check"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-darkBlueBorder;
				font-weight: bold;
			}
		}

		&--paid {
			[class^="icon-check"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-green;
				font-weight: bold;
			}
		}

		&--overpaid {
			[class^="icon-check"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-red;
				font-weight: bold;
			}
		}

		&--sub-row-cell {
			color: Colors.$col-greyFontLight;
		}

		&>b {
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
		}
	}

	&__download-cell {
		color: Colors.$col-blue;
		
		&__text {
			padding-left: Constants.$val-spacing-s;	
		}
	}

	&__email-status {
		&__unknown {
			color: Colors.$col-orangeBorder;
			font-weight: bold;
		}
		&__opened {
			color: Colors.$col-green;
			font-weight: bold;
		}
		&__error {
			color: Colors.$col-canceledRed;
			font-weight: bold;
		}
		&__null {
			color: Colors.$col-design-grey10;
			font-weight: bold;
		}
	}

	.table-container__table__body {
		height: calc(100vh - Table.$var-company-header-height - Table.$var-breadcrumbs-header-height - Table.$var-tabs-navigation-height - Table.$var-table-header-height - Table.$var-table-action-header-height - Table.$var-table-footer-height - 4 * Constants.$val-spacing-xl - 6 * Constants.$val-spacing-m);
	}
}

.invoice-form {

	&__submit-section {
		display: flex;
		align-items: end;
		background-color: Colors.$col-white;
		padding: Constants.$val-spacing-m Constants.$val-spacing-l;
		z-index: 3;
		border-bottom: 2px solid Colors.$col-greyBackground;
		top: $var-submit-action-top-offset;
		position: sticky;

		&__hint {
			color: Colors.$col-greyFontLight;
			font-style: italic;
			flex: 1;
		}
	}

	&__tabs-navigation {
		position: sticky;
		top: $var-tabs-navigation-top-offset;
		z-index: 3;
	}

	&__tab-content {
		display: flex;
		flex-direction: column;
		gap: Constants.$val-spacing-m;
		margin-top: Constants.$val-spacing-s;

		&__form-section {
			background-color: Colors.$col-white;
			box-shadow: $var-shadow;
			padding: Constants.$val-spacing-m Constants.$val-spacing-l;

			&__title {
				text-transform: uppercase;
				color: Colors.$col-design-gray5;
				font-size: Constants.$val-fontSizeSmall;
				margin-bottom: Constants.$val-spacing-m;
			}

			&__row {
				display: grid;
				gap: Constants.$val-spacing-l;
				grid-template-columns: repeat(8, 1fr);

				&__column-1 {
					grid-column: span 1;
				}

				&__column-2 {
					grid-column: span 2;
				}

				&__column-4 {
					grid-column: span 4;
				}

				&__column-6 {
					grid-column: span 6;
				}

				&__column-8 {
					grid-column: span 8;
				}

				&__centered-column {
					display: flex;
					align-items: center;
				}
			}
		}
	}

	&__delete-button {
		margin-top: Constants.$val-spacing-m;

		& > [class^="icon-delete"] {
			color: Colors.$col-grey;
			font-size: Constants.$val-fontSizeBig;
			cursor: pointer;
			margin-top: calc(Constants.$val-spacing-l + Constants.$val-spacing-s);

			&:hover {
				color: Colors.$col-black;
			}
		}
	}

	&__tab {
		display: flex;
		gap: Constants.$val-spacing-xs;
		align-items: center;

		& > [class^="icon-warning"] {
			color: Colors.$col-canceledRed;
			font-size: Constants.$val-fontSizeBig;

		}
	}

	&__add-field-button {
		width: fit-content;
		color: Colors.$col-blue;
		cursor: pointer;
		display: flex;
		align-items: center;
		margin-top: Constants.$val-spacing-m;

		& [class^="icon-plus"] {
			font-size: Constants.$val-fontSizeBig;
			margin-right: Constants.$val-spacing-s;
		}
		&:hover {
			color: Colors.$col-darkBlueBorder;
		}
	}

} 

.attachments-preview {

	&__back-to-list {
		background-color: Colors.$col-white !important;
		margin-bottom: Constants.$val-spacing-m;
	}

	&__submit-section {
		display: flex;
		align-items: center;
		background-color: Colors.$col-white;
		padding: Constants.$val-spacing-m Constants.$val-spacing-l;
		z-index: 3;
		border-bottom: 2px solid Colors.$col-greyBackground;
		top: $var-submit-action-top-offset;
		position: sticky;

		&__status {
			flex: 1;
			display: flex;
			align-items: center;

			&__dropdown {
				>div>div {
					z-index: 100 !important;
				}
			}
		}

		&__actions {
			display: flex;
			gap: Constants.$val-spacing-s;
		}

	}

	&__tabs-navigation {
		position: sticky;
		top: $var-tabs-navigation-top-offset;
	}

	&__tab-content {
		display: flex;
		flex-direction: column;
		gap: Constants.$val-spacing-m;
		margin-top: Constants.$val-spacing-s;

		&__section {
			display: grid;
			row-gap: Constants.$val-spacing-l;
			background-color: Colors.$col-white;
			box-shadow: $var-shadow;
			padding: Constants.$val-spacing-m Constants.$val-spacing-l;

			&__title {
				text-transform: uppercase;
				color: Colors.$col-design-grey11;
				row-gap: 0;
				font-size: Constants.$val-fontSizeSmall;
			}

			&__row {
				display: grid;
				grid-template-columns: repeat(8, 1fr);

				&__column-1 {
					grid-column: span 1;
				}

				&__column-2 {
					grid-column: span 2;
				}

				&__column-4 {
					grid-column: span 4;
				}

				&__column-6 {
					grid-column: span 6;
				}

				&__column-8 {
					grid-column: span 8;
				}

				&__centered-column {
					display: flex;
					align-items: center;
				}
			}
		}
	}


}

@mixin cell-text {
	font-size: Constants.$val-fontSizeSmall;
}

.attachments-preview-table {
	&__cell-text {
		@include cell-text;

		&__blue {
			@include cell-text;
			color: Colors.$col-blue;
			text-transform: uppercase;
		}

		&__uppercase {
			@include cell-text;
			text-transform: uppercase;
		}
	}

	&__light-text {
		@include cell-text;
		color: Colors.$col-design-grey10;
		text-transform: uppercase;
	}
}

.billing-contacts {

	&__hint {
		color: Colors.$col-greyInactive;
		font-style: italic;
		padding-bottom: Constants.$val-spacing-m;
	}

	&__list {
		margin-top: Constants.$val-spacing-s;
		padding-bottom: Constants.$val-spacing-s;

		&__header {
			color: Colors.$col-greyDark;
			margin-bottom: Constants.$val-spacing-s;

			&__number {
				color: Colors.$col-design-gray5;
			}
		}

		&__items {
			padding-bottom: 20px;
		}

		&__item {

			& + & {
				padding-top: Constants.$val-spacing-l;
			}

			&__actions {
				display: flex;
				align-items: center;
				justify-content: flex-start;
				font-size: Constants.$val-fontSizeBig;
				padding-top: Constants.$val-spacing-xs;
				padding-bottom: Constants.$val-spacing-xs;
				padding-right: Constants.$val-spacing-m;

				span {
					color: Colors.$col-design-gray6;
					cursor: pointer;

					&.disabled {
						color: Colors.$col-design-gray5;
						cursor: not-allowed;
					}

					&:not(:first-child) {
						margin-left: Constants.$val-spacing-s;
					}
				}
			}

			&__preview {

				&__header-number {
					padding-left: 8px;
					padding-bottom: Constants.$val-spacing-xs;
				}

				&__field {
					font-weight: bold;
					padding-top: Constants.$val-spacing-xs;
					padding-bottom: Constants.$val-spacing-xs;
					padding-right: 15px;
					margin-left: 8px;
					margin-bottom: Constants.$val-spacing-m;
					background-color: Colors.$col-greyBackground;
				}
			}

			&__edit {
				display: flex;
				flex-direction: row;
				width: 33%;

				&__asterisk {
					color: Colors.$col-orange;
					margin-left: Constants.$val-spacing-xs;
				}

				& + & {
					padding-top: Constants.$val-spacing-l;
				}

				&__actions {
					padding-top: 30px;
					padding-left: 16px;
					font-size: Constants.$val-fontSizeBig;
					color: Colors.$col-blue;

					&--disabled {
						[class^="icon-check"] {
							color: Colors.$col-design-gray5;
							cursor: not-allowed;
						}
					}

					&--red {
						& > span {
							color: Colors.$col-canceledRed !important;
						}
					}

					span {
						color: Colors.$col-design-gray6;
						cursor: pointer;


						&:not(:first-child) {
							margin-left: Constants.$val-spacing-s;
						}
					}
				}
			}
		}
	}
}

.invoices-table {

	&__filter-button {
		border: 1px solid Colors.$col-greyMid;
		border-radius: Constants.$val-borderRadius;
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		display: flex;
		align-items: center;
		background: Colors.$col-white;
		min-width: 120px;
	}
}

